import React from 'react';

const GTop100Logo = () => {
  return (
    <svg width="200" height="50" viewBox="0 0 200 50" xmlns="http://www.w3.org/2000/svg">
      <rect width="200" height="50" fill="#212121" rx="5" ry="5" />
      <text x="20" y="33" fontFamily="Arial" fontSize="20" fill="#ff4d4d" fontWeight="bold">GTop100</text>
      <text x="120" y="33" fontFamily="Arial" fontSize="16" fill="#ffffff">Games</text>
    </svg>
  );
};

export default GTop100Logo;